import PageBanner from "@/components/feature/PageBanner";
import Reveal from "@/components/feature/Reveal";
import InquiryForm from "@/pages/contact/components/InquiryForm";

const contactCards = [
  {
    icon: "ri-phone-line",
    title: "전화 상담",
    lines: ["서울 02-487-9009", "부산 051-741-2045"],
    desc: "평일 09:30 - 18:00",
    href: "tel:024879009",
  },
  {
    icon: "ri-mail-line",
    title: "이메일 문의",
    lines: ["help@dongwoostone.co.kr"],
    desc: "24시간 접수 · 순차 답변",
    href: "mailto:help@dongwoostone.co.kr",
  },
  {
    icon: "ri-store-3-line",
    title: "전시장 방문",
    lines: ["서울 강동구 성내로 19, 6층", "부산 해운대구 달맞이길 120-30, 5층"],
    desc: "예약 후 방문 시 전담 안내",
    href: "#locations",
  },
];

const faqs = [
  {
    q: "견적은 어떻게 받을 수 있나요?",
    a: "도면이나 현장 사진, 원하시는 소재를 문의 폼으로 보내주시면 담당자가 실측 여부를 확인한 뒤 상세 견적을 안내해 드립니다.",
  },
  {
    q: "소재 샘플을 받아볼 수 있나요?",
    a: "네. 문의 접수 시 '카탈로그 요청'을 선택하시면 관심 소재의 소형 샘플과 카탈로그를 함께 보내드립니다.",
  },
  {
    q: "시공 기간은 얼마나 걸리나요?",
    a: "주방 상판 교체는 보통 3~5일, 욕실 전체 시공은 1~2주 정도 소요됩니다. 현장 조건에 따라 달라질 수 있어 실측 후 정확히 안내드립니다.",
  },
  {
    q: "천연석과 인조석 중 어떤 것이 좋을까요?",
    a: "천연석은 결의 깊이와 고급감이 뛰어나고, 인조석은 흡수율이 낮아 관리가 쉽습니다. 사용 공간과 관리 방식에 따라 담당자가 적합한 소재를 추천해 드립니다.",
  },
];

export default function Contact() {
  return (
    <>
      <PageBanner
        eyebrow="CONTACT"
        title="고객문의"
        description="제품 문의부터 견적 요청, 시공 상담까지. 남겨주신 내용을 확인하고 담당자가 직접 연락드립니다."
        image="https://readdy.ai/api/search-image?query=calm%20consultation%20space%20in%20a%20stone%20showroom%20with%20marble%20sample%20boards%20on%20a%20warm%20wood%20table%2C%20soft%20natural%20light%2C%20neutral%20beige%20palette%2C%20refined%20interior%20photography&width=1800&height=900&seq=stone-banner-contact&orientation=landscape"
        imageAlt="석재 샘플이 놓인 상담 공간"
        current="고객문의"
      />

      {/* Contact cards */}
      <section className="bg-background-50">
        <div className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-16">
          <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
            {contactCards.map((card, index) => (
              <Reveal key={card.title} delay={index * 80}>
                <a
                  href={card.href}
                  className="flex h-full cursor-pointer flex-col rounded-lg border border-background-200 bg-background-100 p-6 transition-colors hover:border-primary-300"
                >
                  <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={`${card.icon} text-2xl`} />
                  </span>
                  <h3 className="mt-5 font-heading text-lg text-foreground-950">{card.title}</h3>
                  <ul className="mt-3 space-y-1">
                    {card.lines.map((line) => (
                      <li key={line} className="text-sm text-foreground-700">
                        {line}
                      </li>
                    ))}
                  </ul>
                  <p className="mt-3 text-xs text-foreground-500">{card.desc}</p>
                </a>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Form + side info */}
      <section className="bg-background-100">
        <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-3 lg:gap-12">
            <div className="lg:col-span-2">
              <InquiryForm />
            </div>
            <aside className="space-y-5">
              <div className="rounded-lg border border-background-200 bg-background-50 p-6">
                <h3 className="font-heading text-lg text-foreground-950">상담 가능 시간</h3>
                <ul className="mt-4 space-y-3 text-sm text-foreground-600">
                  <li className="flex items-center justify-between border-b border-background-200 pb-3">
                    <span>평일</span>
                    <span className="font-medium text-foreground-900">09:30 - 18:00</span>
                  </li>
                  <li className="flex items-center justify-between border-b border-background-200 pb-3">
                    <span>토요일</span>
                    <span className="font-medium text-foreground-900">10:00 - 15:00</span>
                  </li>
                  <li className="flex items-center justify-between">
                    <span>일요일 · 공휴일</span>
                    <span className="font-medium text-foreground-500">휴무</span>
                  </li>
                </ul>
              </div>
              <div className="rounded-lg border border-background-200 bg-background-50 p-6">
                <h3 className="font-heading text-lg text-foreground-950">빠른 안내</h3>
                <ul className="mt-4 space-y-3">
                  {[
                    { icon: "ri-file-text-line", text: "도면이 있으면 견적이 더 정확합니다" },
                    { icon: "ri-camera-line", text: "현장 사진을 함께 보내주세요" },
                    { icon: "ri-calendar-check-line", text: "방문 상담은 예약 후 이용해 주세요" },
                  ].map((item) => (
                    <li key={item.text} className="flex items-start gap-3 text-sm text-foreground-600">
                      <i className={`${item.icon} mt-0.5 shrink-0 text-base text-primary-600`} />
                      {item.text}
                    </li>
                  ))}
                </ul>
              </div>
            </aside>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="bg-background-50">
        <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
          <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">자주 묻는 질문</h2>
          <div className="mt-8 divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200">
            {faqs.map((faq) => (
              <details key={faq.q} className="group bg-background-50 px-5 py-4 md:px-6 md:py-5">
                <summary className="flex cursor-pointer list-none items-center justify-between gap-4 text-sm font-medium text-foreground-900 md:text-base">
                  <span className="flex items-start gap-3">
                    <span className="font-heading text-primary-500">Q</span>
                    {faq.q}
                  </span>
                  <i className="ri-add-line shrink-0 text-lg text-foreground-500 transition-transform group-open:rotate-45" />
                </summary>
                <p className="mt-3 pl-7 text-sm leading-relaxed text-foreground-600">{faq.a}</p>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* Locations */}
      <section id="locations" className="bg-background-100">
        <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
          <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">오시는 길</h2>
          <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-2">
            <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <iframe
                title="서울 본사 위치 지도"
                src="https://www.google.com/maps?q=%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C%20%EA%B0%95%EB%8F%99%EA%B5%AC%20%EC%84%B1%EB%82%B4%EB%A1%9C%2019&output=embed"
                aria-label="서울 본사 위치"
                className="h-[240px] w-full border-0"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
              <div className="p-5">
                <h3 className="font-heading text-lg text-foreground-950">서울 본사</h3>
                <p className="mt-2 text-sm text-foreground-600">서울특별시 강동구 성내로 19, 6층</p>
                <p className="mt-1 text-sm text-foreground-600">T. 02-487-9009</p>
              </div>
            </div>
            <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <iframe
                title="부산 전시장 위치 지도"
                src="https://www.google.com/maps?q=%EB%B6%80%EC%82%B0%EA%B4%91%EC%97%AD%EC%8B%9C%20%ED%95%B4%EC%9A%B4%EB%8C%80%EA%B5%AC%20%EB%8B%AC%EB%A7%9E%EC%9D%B4%EA%B8%B8%20120-30&output=embed"
                aria-label="부산 전시장 위치"
                className="h-[240px] w-full border-0"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
              <div className="p-5">
                <h3 className="font-heading text-lg text-foreground-950">부산 전시장</h3>
                <p className="mt-2 text-sm text-foreground-600">부산광역시 해운대구 달맞이길 120-30, 5층</p>
                <p className="mt-1 text-sm text-foreground-600">T. 051-741-2045</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}